import { combineReducers } from 'redux';
import allergiesReducer, {
  allergiesSelector,
  fetchAllergiesAsync,
  saveAllergiesAsync,
} from './allergies';
import dietReducer, {
  DIET_ROUTE,
  dietSelector,
  DIET_TYPE,
  fetchDietAsync,
  saveDietAsync,
} from './diet';
import { fetchPdfExportAsync, fetchTermsAsync } from './export';
import insuranceReducer, {
  fetchInsuranceAsync,
  saveInsuranceAsync,
  insuranceSelector,
} from './insurance';
import medicationsReducer, {
  PRESCRIPTION_ROUTE,
  fetchMedicationsAsync,
  medicationsSelector,
  saveMedicationsAsync,
  searchFdaMedicationsAsync,
} from './medications';
import notificationSettingsReducer, {
  fetchNotificationSettingsAsync,
  notificationSettingsSelector,
  saveNotificationSettingsAsync,
} from './notificationSettings';
import notificationTemplatesReducer, {
  fetchNotificationTemplatesAsync,
  LOCATION_TYPES,
  notificationTemplatesSelector,
  saveNotificationTemplatesAsync,
} from './notificationTemplates';
import patientsReducer, {
  currentPatientIdSelector,
  currentPatientSelector,
  patientSelector,
  setCurrentPatientId,
  setPatients,
  setPatientById,
  updatePatientAsync,
} from './patient';
import pharmaciesReducer, {
  fetchPharmaciesAsync,
  pharmaciesSelector,
  savePharmaciesAsync,
} from './pharmacies';
import primaryCaregiverReducer, {
  fetchPrimaryCaregiverAsync,
  savePrimaryCaregiverAsync,
  primaryCaregiverSelector,
} from './primaryCaregiver';
import primaryDoctorReducer, {
  fetchPrimaryDoctorAsync,
  primaryDoctorSelector,
  savePrimaryDoctorAsync,
} from './primaryDoctor';
import sessionReducer, {
  hasValidSessionSelector,
  isAdminSelector,
  isLoggedInSelector,
  sessionTokenSelector,
  sessionUserSelector,
  sessionUserEmailSelector,
  setIsLoggedIn,
  setSession,
  SET_SESSION,
} from './session';
import specialistsReducer, {
  specialistsSelector,
  fetchSpecialistsAsync,
  saveSpecialistsAsync,
} from './specialists';
import surgeriesReducer, {
  surgeriesSelector,
  fetchSurgeriesAsync,
  saveSurgeriesAsync,
} from './surgeries';
import diagnosesReducer, {
  diagnosisSelector,
  fetchDiagnosesAsync,
  saveDiagnosesAsync,
  searchDiagnosesAsync,
} from './diagnoses';
import usersReducer, {
  changePasswordAsync,
  forgotPasswordAsync,
  fetchUsersAsync,
  removeUserAsync,
  resetPasswordAsync,
  updateUserAsync,
  usersSelector,
} from './user';
import { toISOStringNoZone } from './util';

export {
  allergiesSelector,
  changePasswordAsync,
  currentPatientIdSelector,
  currentPatientSelector,
  DIET_ROUTE,
  DIET_TYPE,
  dietSelector,
  diagnosisSelector,
  fetchAllergiesAsync,
  fetchDiagnosesAsync,
  fetchDietAsync,
  fetchPdfExportAsync,
  fetchInsuranceAsync,
  fetchMedicationsAsync,
  fetchNotificationSettingsAsync,
  fetchNotificationTemplatesAsync,
  fetchPharmaciesAsync,
  fetchPrimaryCaregiverAsync,
  fetchPrimaryDoctorAsync,
  fetchSpecialistsAsync,
  fetchSurgeriesAsync,
  fetchTermsAsync,
  fetchUsersAsync,
  forgotPasswordAsync,
  hasValidSessionSelector,
  insuranceSelector,
  isAdminSelector,
  isLoggedInSelector,
  LOCATION_TYPES,
  PRESCRIPTION_ROUTE,
  medicationsSelector,
  notificationSettingsSelector,
  notificationTemplatesSelector,
  patientSelector,
  pharmaciesSelector,
  primaryCaregiverSelector,
  primaryDoctorSelector,
  removeUserAsync,
  resetPasswordAsync,
  saveAllergiesAsync,
  saveDiagnosesAsync,
  saveDietAsync,
  saveInsuranceAsync,
  saveMedicationsAsync,
  saveNotificationSettingsAsync,
  saveNotificationTemplatesAsync,
  savePharmaciesAsync,
  savePrimaryCaregiverAsync,
  savePrimaryDoctorAsync,
  saveSpecialistsAsync,
  saveSurgeriesAsync,
  searchDiagnosesAsync,
  searchFdaMedicationsAsync,
  sessionTokenSelector,
  sessionUserSelector,
  sessionUserEmailSelector,
  setCurrentPatientId,
  setIsLoggedIn,
  setPatientById,
  setPatients,
  setSession,
  SET_SESSION,
  specialistsSelector,
  surgeriesSelector,
  toISOStringNoZone,
  updatePatientAsync,
  updateUserAsync,
  usersSelector,
};

export * from './constants';
export * from './selectors';
export * from './thunks';

export default combineReducers({
  allergies: allergiesReducer,
  diet: dietReducer,
  diagnoses: diagnosesReducer,
  insurance: insuranceReducer,
  medications: medicationsReducer,
  notificationSettings: notificationSettingsReducer,
  notificationTemplates: notificationTemplatesReducer,
  patients: patientsReducer,
  pharmacies: pharmaciesReducer,
  primaryDoctor: primaryDoctorReducer,
  primaryCaregiver: primaryCaregiverReducer,
  session: sessionReducer,
  specialists: specialistsReducer,
  surgeries: surgeriesReducer,
  users: usersReducer,
});



// WEBPACK FOOTER //
// ./src/lib/dataLayer/index.js